<div class="one-filter row">
    <div class="col-md-11">
        <div class="row">
            <form [formGroup]="searchFormGroup">
                <mat-form-field class="col-md-3" appearance="fill">
                    <mat-label class="title">{{text.STATUS_FILTER.TEXT}}</mat-label>
                    <mat-select formControlName="status">
                        <mat-option *ngFor="let status of statuses" [value]="status.value">{{status.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            
                <mat-form-field class="col-md-3" appearance="fill">
                    <mat-label class="title">Nhóm đề xuất</mat-label>
                    <mat-select formControlName="requestGroup" #singleSelect>
                      <mat-option>
                        <ngx-mat-select-search placeholderLabel="Tìm kiếm"
                          noEntriesFoundLabel="Không tìm thấy"
                          [formControl]="requestGroupFilter"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option value="">Tất cả</mat-option>
                      <mat-option *ngFor="let requestGroup of filteredRequestGroups | async" [value]="requestGroup.oId">
                        {{requestGroup.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
            
                <mat-form-field class="col-md-3" appearance="fill">
                    <mat-label class="title">Thời gian tạo</mat-label>
                    <mat-date-range-input [formGroup]="searchFormGroup.controls.submitTime" [rangePicker]="picker">
                        <input matStartDate formControlName="start" placeholder="Start date">
                        <input matEndDate formControlName="end" placeholder="End date">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
            
                <mat-form-field class="col-md-3" appearance="fill">
                    <mat-label class="title">Người tạo</mat-label>
                    <mat-select formControlName="submitters" multiple>
                        <mat-option>
                            <ngx-mat-select-search placeholderLabel="Tìm kiếm"
                                noEntriesFoundLabel="Không tìm thấy"
                                [formControl]="userFilter"></ngx-mat-select-search>
                        </mat-option>
                      <mat-option *ngFor="let user of filteredUsers | async" [value]="user.username">{{user.fullName}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  
            </form>
        </div>
    </div>
    <div class="col-md-1">
        <button mat-button color="primary" (click)="onSearch()">{{text.SEARCH_TEXT}}</button>
    </div>
</div>